import { Button, Modal } from "antd";
import { DatePicker, FontFa, Icon, Table } from "../../../components";
import "./statistic-modal.scss";
import { ColumnsType } from "antd/lib/table";
import { Employee } from "../../../services/department-viags/employee-viags.service";
import { DateFormat } from "../../../constants";
import { UserDocsType } from "../../../services/department-viags/statistics-employee.service";
import { Moment } from "moment";
import { getDDMMYYYFormat } from "../../../helper/dateTimeHelper";
import { downloadExcel } from "react-export-table-to-excel";
import { useSearchParams } from "../../../hook/use-search-params";
import { useDocsOfUser } from "../hooks/use-doc-of-user";

type UseDocumentModalType = {
  onClose: () => void;
  isOpen: boolean;
  selectedEmployee: Employee;
};

type RangeValue = [Moment | null, Moment | null] | null;

export const UserDocumentModal = (props: UseDocumentModalType) => {
  const { onClose, isOpen, selectedEmployee } = props;
  const {
    filteredData: docsOfUserData,
    isLoading,
    countReadDocument,
    countUnReadDocument,
    countTotalDocument,
  } = useDocsOfUser();
  const { searchParams, pushSearchParams } = useSearchParams();

  const columns: ColumnsType<any> = [
    {
      title: "Mã tài liệu",
      dataIndex: "docCode",
      key: "docCode",
      align: "center" as const,
      width: 120,
    },
    {
      title: "Tên tài liệu",
      dataIndex: "docName",
      key: "docName",
    },
    {
      title: "Loại tài liệu",
      dataIndex: "docType",
      key: "docType",
    },
    {
      title: "Tình Trạng",
      dataIndex: "docStatus",
      key: "docStatus",
    },
    {
      title: "Ngày ban hành",
      dataIndex: "publishDay",
      render: (date: string) => getDDMMYYYFormat(date),
      key: "publishDay",
    },
    {
      title: "Ngày hết hiệu lực",
      dataIndex: "effectiveDate",
      render: (date: string) => getDDMMYYYFormat(date),
      key: "effectiveDate",
    },
    {
      title: "Đã đọc",
      dataIndex: "seen",
      key: "seen",
      render: (isRead: any) => isRead && <FontFa name="faCheckCircle" color="#3DE91A" />,
      align: "center" as const,
    },
    {
      title: "Chưa đọc",
      dataIndex: "seen",
      key: "seen",
      render: (isRead: any) => !isRead && <FontFa name="faTimesCircle" color="#EE4E25" />,
      align: "center" as const,
    },
  ];

  const onDateChange = (dates: RangeValue) => {
    if (dates) {
      const [startDate, endDate] = dates;
      searchParams.set("start", startDate?.startOf("day")?.toISOString() || "");
      searchParams.set("end", endDate?.endOf("day")?.toISOString() || "");
      pushSearchParams(searchParams);
    } else {
      searchParams.delete("start");
      searchParams.delete("end");
      pushSearchParams(searchParams);
    }
  };

  const handleExport = () => {
    let result: any = docsOfUserData?.map((dou: UserDocsType) => {
      return {
        ...dou,
        publishDay: getDDMMYYYFormat(dou.publishDay),
        effectiveDate: getDDMMYYYFormat(dou.effectiveDate),
        seen: dou.seen ? "✔" : "",
        unseen: dou.seen ? "" : "❌",
      };
    });

    const exportContent: {
      fileName: string;
      sheet?: string;
      content: Array<{ header: string; dataIndex: string }>;
    } = {
      fileName: "ThongKeTaiLieu_" + selectedEmployee?.employeeName,
      content: [
        { header: "Mã tài liệu", dataIndex: "docCode" },
        { header: "Tên tài liệu", dataIndex: "docName" },
        { header: "Loại tài liệu", dataIndex: "docType" },
        { header: "Tình Trạng", dataIndex: "docStatus" },
        { header: "Ngày ban hành	", dataIndex: "publishDay" },
        { header: "Ngày hết hiệu lực	", dataIndex: "effectiveDate" },
        { header: "Đã đọc", dataIndex: "seen" },
        { header: "Chưa đọc", dataIndex: "unseen" },
      ],
    };

    const body = result.map((e: any) => {
      let obj: any = {};
      exportContent.content
        .map((e) => e.dataIndex)
        .forEach((key, i) => {
          obj[i] = e[key];
        });
      return obj;
    });

    downloadExcel({
      fileName: exportContent.fileName,
      sheet: exportContent?.sheet || "Sheet 1",
      tablePayload: {
        header: exportContent.content.map((e) => e.header),
        body,
      },
    });
  };

  return (
    <Modal
      open={isOpen}
      zIndex={1552}
      width={1280}
      cancelText="Đóng"
      onCancel={onClose}
      centered
      okButtonProps={{ hidden: true }}
      closable={false}
      destroyOnClose
    >
      <div className="modal-title">
        <div className="modal-left">
          <div>
            <h5 style={{ color: "#00a9c4" }}>Bảng thống kê danh sách tài liệu ban hành cho người dùng</h5>
          </div>
          <div className="d-flex column">
            <p className="mx-2">
              <span style={{ fontWeight: "bold" }}>Tài liệu ban hành đến: </span>
              {selectedEmployee?.employeeName}
            </p>
          </div>
          <div className="d-flex column">
            <p className="mx-2">Tổng cộng: {countTotalDocument}</p>
            <p className="mx-2">
              Đã đọc: <span className="text-success">{countReadDocument}</span>
            </p>
            <p className="mx-2">
              Chưa đọc: <span className="text-danger">{countUnReadDocument}</span>
            </p>
          </div>
        </div>
        <div className="modal-right">
          <div className="modal-date-picker py-2">
            <span className="modal-date-text">Thời gian ban hành/triển khai</span>
            <DatePicker.RangePicker
              popupStyle={{ zIndex: 1553 }}
              onCalendarChange={onDateChange}
              placeholder={["Ngày bắt đầu", "Ngày kết thúc"]}
              format={DateFormat.DD_MM_YYY}
            />
          </div>
          <Button type="primary" onClick={handleExport}>
            Xuất excel
          </Button>
        </div>
      </div>

      <div className="modal-body px-0 pb-0">
        {isLoading ? (
          <div className="tableLoading">
            <Icon.Loading />
          </div>
        ) : (
          <Table
            rowKey="id"
            columns={columns}
            showHeader={true}
            dataSource={docsOfUserData}
            pagination={{ pageSize: 7 }}
          />
        )}
      </div>
    </Modal>
  );
};
